import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MijnInterfaceCacheService } from '@ap/mijn-interface-cache';

import {
    Klantinstelling,
    LijstVanCategorieen,
    LijstVanKlantinstellingen,
    LijstVanKlantinstellingTypes
} from './klantinstellingenbeheer.model';

const CACHE_TTL = 3;

@Injectable({ providedIn: 'root' })
export class KlantinstellingenbeheerResource {
    private readonly baseUrl: string = '/services/apic-klantinstellingenbeheer/api';

    public constructor(
        private readonly httpClient: HttpClient,
        private readonly mijnCacheService: MijnInterfaceCacheService
    ) {}

    public getCategorieen(): Observable<LijstVanCategorieen> {
        return this.httpClient.get<LijstVanCategorieen>(`${this.baseUrl}/categorieen`);
    }

    public getKlantinstellingTypes(): Observable<LijstVanKlantinstellingTypes> {
        return this.httpClient.get<LijstVanKlantinstellingTypes>(`${this.baseUrl}/klantinstelling-types`);
    }

    public getKlantinstellingen(categorie?: string, klantinstellingType?: string): Observable<LijstVanKlantinstellingen> {
        let params = new HttpParams();

        if (categorie) {
            params = params.set('categorie', categorie);
        }
        if (klantinstellingType) {
            params = params.set('klantinstelling_type', klantinstellingType);
        }

        return this.mijnCacheService.getData<LijstVanKlantinstellingen>(this.baseUrl, 'klantinstellingen', CACHE_TTL, params);
    }

    public getKlantinstelling(id: string): Observable<Klantinstelling> {
        return this.mijnCacheService.getData<Klantinstelling>(this.baseUrl, `klantinstellingen/${id}`, CACHE_TTL);
    }

    public createOrUpdateKlantinstelling(klantinstelling: Klantinstelling): Observable<void> {
        this.mijnCacheService.clearCache(this.baseUrl, `klantinstellingen`);
        return this.httpClient.put<void>(`${this.baseUrl}/klantinstellingen`, klantinstelling);
    }

    public deleteKlantinstelling(id: string): Observable<void> {
        this.mijnCacheService.clearCache(this.baseUrl, `klantinstellingen/${id}`);
        return this.httpClient.delete<void>(`${this.baseUrl}/klantinstellingen/${id}`);
    }
}
